/**
 * @fileoverview Features grid component showing ISCRI key features
 * @author ISCRI Team
 */

import "./styles/FeaturesGrid.css";

/**
 * Features grid component with key ISCRI capabilities
 * Replicates feature cards from iscri.html
 * @returns {JSX.Element} Features grid component
 */
const FeaturesGrid = () => {
  const features = [
    {
      icon: "📊",
      title: "Real-Time Tracking",
      description:
        'ISCRI is a new "Interstate Conflictual Relations Index" which tracks in real time geopolitical tensions between countries.',
    },
    {
      icon: "🗃️",
      title: "Data Source",
      description:
        "It is based on the automatic coding of media news recorded in the Global Data on Events, Location, and Tone (GDELT) database.",
    },
    {
      icon: "🔍",
      title: "Comprehensive Analysis",
      description:
        "Our Index can distinguish between verbal and material conflicts, follows best practices, and is available for virtually all country-pairs in the world since 2015.",
    },
    {
      icon: "⚠️",
      title: "Early Warning",
      description:
        "It provides a novel early warning synthetic signal specific to each country-pair.",
    },
  ];

  return (
    <section className="features-section reveal-element">
      <div className="container">
        <div className="features">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;